<template>
	<div class="">
		<div class="publish_item ">
			<div style="width: 60rem;margin: 0 auto;">
				<span class="title" style="font-size: 1rem;font-weight: bold;position: relative">设定产品标签</span>
			</div>
			<div class="base_info position-relative">
				<div style="margin-top: 0.875rem;">
					<el-radio-group v-model="radio" @input="sel()">
					    <el-radio :label="1" >选择标签</el-radio>
					    <el-radio :label="2" >自定义标签内容</el-radio>
					</el-radio-group>
				</div>
				<div style="width: 100%;box-sizing: border-box;margin-top: 1.25rem;" class="d-flex a-center">
					<template v-if="radio==1">
						<div class="top-nav" v-for="(item,index) in nav" :key="index" :class="cur_navIndex==index?'active-nav':'commen-nav'" @click="selNav(item,index)">
							{{item.label}}
						</div>
					</template>
					<template v-else>
						<input type="text" v-model="zdy_label"
						placeholder="如：医疗器械" style="width: 22rem;height: 24px;border-radius: 2px;font-size: 12px;box-sizing: border-box;padding: 0 0.8125rem;">
					</template>
				</div>
				<div style="width: 100%;box-sizing: border-box;margin-top: 1.25rem;" class="">
					<div v-for="(item,index) in goods_catalogue_list" :key="index" style="width: 100%;box-sizing: border-box;margin-bottom: 1.875rem;">
						<div style="width: 100%;box-sizing: border-box;" class="d-flex a-center">
							<div style="width: 250px;height: 24px;border: 1px solid #BBBBBB;box-sizing: border-box;padding: 0 8px;font-size: 12px;color: #888888;" class="d-flex a-center j-sb">
								分类名称：
								<div style="color: #000000;font-weight: 600;">{{item.cat_name}}</div>
							</div>
							 <el-button @click="zhyAddGoods(item,index)" type="primary" plain size="mini" style="width: 5rem;margin-left: 1.25rem;">手动添加</el-button>
						</div>
						<div style="width: 100%;box-sizing: border-box;margin-top: 1.0625rem;margin-left: auto;" class="goods-lb d-flex j-sb flex-wrap">
							<div style="width: 33%;margin-bottom: 1.25rem;box-sizing: border-box;" v-for="(goods,goodsIndex) in item.goods_list" :key="goodsIndex">
								<div class="w-100 d-flex j-sb" style="box-sizing: border-box;">
									<div style="flex: 1;color: #666666;font-size: 0.75rem;margin-right: 2.5rem;" class="text-hide-2">{{goods.goods_name}}</div>
									<div style="width: 3.75rem;height: 16px;border: 1px solid #000000;box-sizing: border-box;font-size: 12px;color: #000000;cursor: pointer;"
									 class="d-flex a-center j-center" @click="setBq(item,index,goods,goodsIndex)">
										{{goods.label!=''?'取消标签':'设定标签'}}
									</div>
								</div>
								<div style="color: #1E69FF;font-size: 12px;margin-top: 10px;font-weight: 600;" v-if="goods.label!=''">{{goods.label}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="buttons d-flex a-center j-center" style="justify-content: space-around;">
			<el-button plain style="width: 7.125rem;height: 26px;" size="mini">取消</el-button>
			<el-button type="primary" @click="submit" style="width: 7.125rem;height: 26px;background-color:#226CFF;margin-left:36px;" size="mini">发布</el-button>
		</div>
		<el-dialog
		  title="手动添加产品"
		  :visible.sync="showfile"
		  width="600px"
		  top="440px"
		  center>
		  <div style="padding: 0 20px 20px 20px;background: #FFFFFF;">
			<input type="text" placeholder="请输入产品名称" 
			style="font-size: 12px;font-weight: 600;width: 100%;height: 1.5rem;box-sizing: border-box;padding: 0 0.875rem;" v-model="cur_goods_name">
		  </div>
		  <div class="d-flex a-center j-center" style="margin-top: 20px;">
				<div @click="showfile=false" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #cccccc;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;">
					取消
				</div>
				<div @click="add()" style="cursor: pointer;color: #FFFFFF;font-size: 12px;width: 114px;height: 26px;background: #1E69FF;
				border-radius: 4px;display: flex;align-items: center;justify-content: center;margin-left: 30px;">
					确定
				</div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:localStorage.getItem('token'),
				user_id:localStorage.getItem('user_id'),
				showfile:false,
				radio:1,
				nav:[{label:'重点推荐'},{label:'重点产品'},{label:'主打产品'}],
				cur_navIndex:0,
				cur_navLabel:'重点推荐',
				zdy_label:'',
				goods_catalogue_list:[],
				cur_goods_name:'',
				curIndex:null
			}
		},
		methods: {
			//获取企业商品目录
			admin_get_business_goods_catalogue(){
				let params={
					act:'admin_get_business_goods_catalogue',
					token:this.token,
					user_id:this.user_id
				}
				this.$api.admin_get_business_goods_catalogue(params).then((res)=>{
					if(res.code==0){
						this.goods_catalogue_list=res.data
					}
				})
			},
			setBq(item,index,goods,goodsIndex){
				if(this.radio==1){
					if(goods.label==''){
						goods.label=this.cur_navLabel
					}else{
						goods.label=''
					}
				}else{
					if(goods.label==''){
						if(this.zdy_label==''){
							this.$message({
								showClose: true,
								message: '请先填写自定义标签内容',
								type: 'error',
								offset: 350,
								duration: 2000
							})
						}else{
							goods.label=this.zdy_label
						}
						
					}else{
						goods.label=''
					}
				}
			},
			selNav(item,index){
				this.cur_navIndex=index
				this.cur_navLabel=item.label
				this.admin_get_business_goods_catalogue()
			},
			sel(){
				this.admin_get_business_goods_catalogue()
			},
			zhyAddGoods(item,index){
				this.showfile=true
				this.curIndex=index
			},
			add(){
				this.goods_catalogue_list[this.curIndex].goods_list.push({
					goods_id:0,
					goods_name:this.cur_goods_name,
					label:'',
					type:1
				})
				this.cur_goods_name=''
				this.showfile=false
				this.curIndex=null
			},
			submit(){
				let params={
					act:'admin_save_business_goods_catalogue',
					token:this.token,
					user_id:this.user_id,
					catalogue_data:JSON.stringify(this.goods_catalogue_list)
				}
				const loading = this.$loading({
					lock: true,
					text: '发布中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$api.admin_save_business_goods_catalogue(params).then((res)=>{
					loading.close()
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'success',
							offset: 350,
							duration: 2000
						})
					}else {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			}
		},
		mounted() {
			this.admin_get_business_goods_catalogue()
		}
	}
</script>

<style lang="scss">
	.el-cascader-menu {
		width: 33.3%;
	}

	.el-cascader-node {
		padding: 0 2rem 0 1rem !important;
	}

	.el-cascader {
		.el-input__inner {
			font-size: 0.75rem;
		}
	}

	.in-active-path {
		color: #1E69FF !important;
		background: #EEF4FF !important;

		&::before {
			content: '';
			width: 0.13rem;
			height: 1.25rem;
			background: #1E69FF;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.is-active {
		color: #1E69FF !important;
		background: #EEF4FF !important;
	}

	.el-scrollbar__wrap {
		overflow: auto !important;
		margin-right: -6px !important;
	}

	.el-scrollbar__view,
	.el-cascader-menu__list {
		padding: 0 !important;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.el-upload--text {
		width: 100%;
		height: 100%;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100%;
		height: 100%;
		line-height: 100%;
		text-align: center;
	}

	.avatar {
		width: 7.5rem;
		height: 7.5rem;
		display: block;
	}

	.el-upload-list--picture {
		position: absolute;
		left: 0;
		top: 3.13rem;
		width: 100% !important;

		.el-upload-list__item,
		.is-success {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.el-progress,
	.el-progress--circle,
	.el-progress-circle {
		width: 100% !important;
		height: 100% !important;
	}
</style>
<style lang="scss" scoped>
	::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.text-suojin{
		 overflow: hidden;
		 text-overflow: ellipsis;
		 display: -webkit-box; 
		 -webkit-line-clamp: 2;
		 -webkit-box-orient: vertical;
	}
	.tableHead div:first-child{
		border-left: 2px solid #BBBBBB;
	}
	.tableBody div{
		border-top: 0px solid #BBBBBB !important;
	}
	input[type="checkbox"] {
		width: 1.13rem;
		height: 1.13rem;
		-webkit-appearance: none;
		border: 1px solid #c9c9c9;
		border-radius: 10px;
		outline: none;
		cursor: pointer;
	}
	input[type=checkbox]:checked {
		background: url("../../assets/itemStore/xuanzhong@2x.png")no-repeat;
		background-size: 100% 100%;
	}
	.publish_item {
		max-width: 73.13rem;
		box-sizing: border-box;
		height: 850px;
		margin: 1.25rem auto;
		background: #FFFFFF;
		padding: 1.81rem 0 3.63rem 0;
		border-radius: 0.625rem;
		.base_info {
			width: 60rem;
			margin: 0 auto;
			overflow-y: scroll;
			height: 48.125rem;
			// margin-top: 3rem;
		}
	}
	.buttons {
		max-width: 73.13rem;
		height: 3.125rem;
		background-color: #FFFFFF;
		margin: 0 auto;
		border-radius: 0.25rem;
	}
	.top-nav{
		width: 6.25rem;
		height: 24px;
		margin-right: 1.625rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		border-radius: 0.125rem;
		cursor: pointer;
	}
	.commen-nav{
		color: #888888;
		border: 1px solid #888888;
	}
	.active-nav{
		border: 1px solid #1E69FF;
		color: #1E69FF;
		font-weight: 700;
	}
	.goods-lb::after{
		content: '';
		width: 33%;
	}
</style>
